import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { Driver } from 'interfaces/driver';

const { Types, Creators } = createActions(
  {
    request: ['postData', 'onSuccess'],
    success: [],
    failure: ['error', 'validationErrors'],
    reset: [],
  },
  { prefix: 'UPLOAD_VACCINE_CERTIFICATE_' }
);

export interface UploadVaccineCertificateState {
  loading: boolean;
  error: string | null;
  validationErrors: Record<string, any>[];
}

export interface UploadVaccineCertificateRequest {
  postData: Record<string, unknown>;
  onSuccess?: (driver: Driver) => void;
}

interface Failure {
  error: string;
  validationErrors: Record<string, any>[];
}

const INITIAL_STATE: UploadVaccineCertificateState = {
  loading: false,
  error: null,
  validationErrors: [],
};

const request = (state: UploadVaccineCertificateState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: UploadVaccineCertificateState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: UploadVaccineCertificateState, action: Failure) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
    validationErrors: { $set: action.validationErrors },
  });

const reset = () => INITIAL_STATE;

export const uploadVaccineCertificate = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UploadVaccineCertificateTypes = Types;
export const UploadVaccineCertificateActions = Creators;
